export const STUDENT_MODE = "STUDENT_MODE";
export const DLS_MODE = "DLS_MODE";
export const PRESENTATION_MODE = "PRESENTATION_MODE";

export default {
  [STUDENT_MODE]: {
    label: "Schulbuch",
    value: STUDENT_MODE
  },
  [DLS_MODE]: {
    label: "Der Unterrichtsgestalter",
    value: DLS_MODE
  },
  [PRESENTATION_MODE]: {
    label: "Präsentation",
    value: PRESENTATION_MODE
  }
};
